(() => {
const root=window.Shopify.routes.root;
const box=document.getElementById('sb-schedule');
let ready=false;
if(box){
const c=JSON.parse(box.dataset.config),a=JSON.parse(box.dataset.attributes||'{}'),form=box.querySelector('form'),method=document.getElementById('sb-method'),date=document.getElementById('sb-date'),time=document.getElementById('sb-time'),status=document.getElementById('sb-status');
const parts=d=>Object.fromEntries(new Intl.DateTimeFormat('en-CA',{timeZone:'America/Toronto',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(d).map(p=>[p.type,p.value]));
const minutes=s=>/^\d{2}:\d{2}$/.test(s)?Number(s.slice(0,2))*60+Number(s.slice(3)):NaN;
const stamp=p=>p.year+'-'+p.month+'-'+p.day;
const threshold=()=>parts(new Date(Date.now()+Number(c.notice)*3600000));
function slots(){
const prior=time.value;time.replaceChildren(new Option('Please select',''));
const limit=threshold();date.min=stamp(limit);
time.disabled=true;time.setCustomValidity('');
status.textContent=!method.value?'Choose local delivery or store pickup first.':!date.value?'Choose a date to see available times.':'';
const day=new Date(date.value+'T12:00:00Z').getUTCDay();
const blocked=c.closedDays.split(',').map(v=>v.trim()).includes(String(day))||c.closedDates.split(',').map(v=>v.trim()).includes(date.value);
date.setCustomValidity(blocked?'This date is unavailable. Please choose another date.':'');
if(!method.value||!date.value)return;
if(blocked||date.value<date.min){status.textContent=blocked?'This date is unavailable. Please choose another date.':'Please choose a date on or after '+date.min+'.';return;}
const pickup=method.value==='Store pickup',start=minutes(pickup?c.pickupOpen:c.deliveryOpen),end=minutes(pickup?c.pickupClose:c.deliveryClose),step=Number(c.interval);
for(let m=start;m+step<=end;m+=step){
if(date.value===date.min&&m<Number(limit.hour)*60+Number(limit.minute))continue;
const fmt=n=>String(Math.floor(n/60)).padStart(2,'0')+':'+String(n%60).padStart(2,'0');
const label=n=>new Date(Date.UTC(2020,0,1,Math.floor(n/60),n%60)).toLocaleTimeString('en-CA',{timeZone:'UTC',hour:'numeric',minute:'2-digit'});
time.add(new Option(label(m)+' – '+label(m+step),fmt(m)+' – '+fmt(m+step)));
}
time.disabled=false;
if(time.options.length===1){time.setCustomValidity('No times are available on this date. Please choose a later date.');status.textContent='No times are available on this date with the '+c.notice+'-hour notice requirement. Please choose a later date.';}
time.value=prior;
if(!time.value)time.value='';
}
method.value=a['Fulfillment method']||'';
const radios=box.querySelectorAll('input[name="sb-fulfillment"]');
radios.forEach(r=>{r.checked=r.value===method.value;r.addEventListener('change',()=>{method.value=r.value;time.value='';slots();});});date.value=a['Requested date']||'';slots();if(Array.from(time.options).some(o=>o.value===a['Requested time']))time.value=a['Requested time'];
box.addEventListener('change',e=>{ready=false;if(e.target===date)slots();else if(e.target===time)status.textContent='';});
window.sbSave=async()=>{
slots();if(!method.value||!date.value||time.disabled||!time.value||!form.reportValidity()){box.scrollIntoView({behavior:'smooth',block:'center'});return false;}
status.textContent='Saving your selection…';
try{
const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Fulfillment method':method.value,'Requested date':date.value,'Requested time':time.value,'Schedule timezone':'America/Toronto'}})});
if(!response.ok)throw new Error('save');
const cart=await response.json();
if(cart.attributes['Fulfillment method']!==method.value||cart.attributes['Requested date']!==date.value||cart.attributes['Requested time']!==time.value)throw new Error('save');
status.textContent='Your selection is saved.';ready=true;return true;
}catch(e){status.textContent='We could not save your selection. Please try checkout again.';return false;}
};
form.addEventListener('submit',e=>e.preventDefault());
}
const checkoutSelector='[name="checkout"],a[href*="/checkout"]';
document.addEventListener('click',async e=>{
const target=e.target.closest(checkoutSelector);if(!target)return;
e.preventDefault();e.stopImmediatePropagation();
if(!box){window.location.href=root+'cart';return;}
if(await window.sbSave())window.location.href=root+'checkout';
},true);
document.addEventListener('submit',async e=>{
if(e.submitter?.name!=='checkout')return;
e.preventDefault();e.stopImmediatePropagation();
if(!box){window.location.href=root+'cart';return;}
if(await window.sbSave())window.location.href=root+'checkout';
},true);
})();